import React from 'react';

import { TWELVE_HOUR_TIME_PARSE_FORMAT } from 'features/store/constants';
import { readableHour } from 'features/store/utils';
import { StyleSheet } from 'react-native';
import { Typography } from 'ucl/components/text/Typography';

import { IServerOrder } from '@rbi-ctg/menu';
import { Box } from 'components/ui/box';
import useOrderNumber from 'hooks/use-order-number';
import { t } from 'state/intl/translations';
import { spacing } from 'styles/constants';
import { getConfigValue } from 'utils/environment';

import { CardHeading, CardHeadingContainer, CardText } from '../styled';

interface IDeliveryOrderDetails {
  serverOrder: IServerOrder;
}

const DeliveryOrderDetails = ({ serverOrder }: IDeliveryOrderDetails) => {
  const orderNumber = useOrderNumber(serverOrder);
  const cardType = serverOrder?.cart?.payment?.cardType || null;
  const ccLast4 = serverOrder?.cart?.payment?.ccLast4 || null;

  const timeFormatConfig = getConfigValue({
    key: 'timeFormat',
    defaultValue: TWELVE_HOUR_TIME_PARSE_FORMAT,
  });

  const isCashApp = cardType === 'CASHAPP';

  return (
    <CardHeadingContainer>
      <CardHeading>{t('orderDetailsHeading')}</CardHeading>

      <Box style={styles.detailsContainer}>
        {orderNumber ? (
          <CardText>
            <Typography bold>{t('orderNumber')}: </Typography>
            {orderNumber}
          </CardText>
        ) : null}
        {cardType && ccLast4 && !isCashApp && (
          <CardText>
            <Typography bold>{t('payment')}: </Typography>
            {t('paymentXEndingInY', {
              cardType,
              ccLast4,
            })}
          </CardText>
        )}
        {isCashApp && (
          <CardText>
            <Typography bold>{t('payment')}: </Typography>
            {t('cashAppPay')}
          </CardText>
        )}
        <CardText>
          <Typography bold>{t('orderTime')}: </Typography>
          {readableHour({
            timeISOString: serverOrder.createdAt,
            timeFormat: timeFormatConfig,
          })}
        </CardText>
      </Box>
    </CardHeadingContainer>
  );
};

const styles = StyleSheet.create({
  detailsContainer: {
    marginTop: spacing.$4,
  },
});

export default DeliveryOrderDetails;
